var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/shopping"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3005"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 452",
    d: "M32 9.60004V26.4C32 27.9464 30.7464 29.2 29.2 29.2H6.8C5.2536 29.2 4 27.9464 4 26.4V22.5648C4 22.5648 6.66018 21.8376 6.66018 18.6276C6.66018 15.4176 4 14.5728 4 14.5728V9.60005C4 8.05365 5.2536 6.80005 6.8 6.80005H29.2C30.7464 6.80005 32 8.05365 32 9.60004Z",
    stroke: "white",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 331",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 15.2 11.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 375",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 15.2 17)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 376",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "matrix(-1 0 0 1 15.2 22.5)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconCoupon);
export default __webpack_public_path__ + "static/media/nav_icon_coupon.c27df907ddb57a8e35d80afef739c249.svg";
export { ForwardRef as ReactComponent };